import SortingListView from "@/common/custom-lists/SortingListView";
import Pagination from "@/common/tables/Pagination";
import _ from "lodash";
import { useState, useMemo } from "react";
import { connect } from "react-redux";
import PayslipRow from "./payslip/PayslipRow";
import { Actions as ACTIONS } from "../../store/actions/payslipActions";
import TaxModal from "./payslip/TaxModal";

const PayslipTable = ({ payslips, columns, itemsPerPage, location, loading }) => {
	const [sortType, setSortType] = useState(location == "payrollHistory" ? "asc" : "desc");
	const [sortBy, setSortBy] = useState(location == "payrollHistory" ? "employee" : "periodDate");

	const [page, setPage] = useState(0);
	const start = page * (itemsPerPage || 12);
	const end = (page + 1) * (itemsPerPage || 12);

	const filteredPayslips = useMemo(() => {
		const filteredResult = payslips; //?.filter((payslip) => {});

		return _.orderBy(
			filteredResult,
			[(payslip) => payslip.periodDescription === "Unknown Period", sortBy],
			["asc", sortType],
		);
	}, [payslips, sortBy, sortType]);

	return (
		<>
			<TaxModal />
			<div className="content">
				<div
					className="p-0"
					style={{ backgroundColor: "#ECEFF1", borderRadius: 10 }}
				>
					<div
						className="col-xs-12 p-4"
						style={{
							backgroundColor: "#ECEFF1",
							borderRadius: 10,
						}}
					>
						<div
							className="col-xs-12 p-3"
							style={{
								display: "flex",
								justifyContent: "center",
								backgroundColor: "white",
								borderRadius: 10,
								boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
								minHeight: 36,
							}}
						>
							<Pagination
								itemsPerPage={itemsPerPage}
								items={filteredPayslips}
								page={page}
								setPage={setPage}
								loading={loading}
							/>
						</div>
					</div>
					<div className="clearfix" />
					<SortingListView
						{...{
							title: "Payslips",
							items: filteredPayslips?.slice(start, end)?.map((payslip) => (
								<PayslipRow
									payslip={payslip}
									key={payslip.id}
									location={location}
								/>
							)),
							columns,
							sortBy,
							setSortBy,
							sortType,
							setSortType,
						}}
					/>
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => {
	return {
		org: state.company?.settings?.org,
		loading: state.employee.loading?.payslips,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getPayslips: (params) => dispatch(ACTIONS.getPayslips(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PayslipTable);
